import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { FLIGHT_FEATURE_FLAGS } from '@reward-platform/featureFlags'
import { useFeatureFlag } from '~/context/featureFlag'
import { useLocalisation } from '~/context/localisation'
import { useNotification } from '~/context/notification'
import { usePlatformConfig } from '~/context/platform'
import { getAviosOnlyPromotion } from '~/services/contentService'
import { GenericClientError } from '~/utils/errors'

export const useAviosOnlyPromotion = (preview = false) => {
  const { locale } = useLocalisation()
  const { opCo } = usePlatformConfig()
  const { addErrorCodeNotification } = useNotification()
  const flightsAviosOnlyEnabled = useFeatureFlag(FLIGHT_FEATURE_FLAGS.flightsAviosOnly)
  const contentfulPreviewModeEnabled = useFeatureFlag('contentful-preview-mode')
  const isPreviewEnabled = preview && contentfulPreviewModeEnabled

  const {
    data: aviosOnlyPromotionContent,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ['aviosOnlyPromotion', opCo, locale],
    queryFn: ({ signal }) => getAviosOnlyPromotion(opCo, signal, locale, isPreviewEnabled),
    enabled: flightsAviosOnlyEnabled,
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('CONTENT_AVIOS_ONLY_PROMOTION_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  return { aviosOnlyPromotionContent, isLoading }
}
